import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

@Directive({
  selector: '[appClickOutsideExcept]'
})
export class ClickOutsideExceptDirective {
  @Input() appClickOutsideExcept: string | string[] = []; // selectors to ignore
  @Output() clickOutside = new EventEmitter<void>();

  constructor(private eRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    const target = event.target as HTMLElement;
    // If clicked inside host → ignore
    if (this.eRef.nativeElement.contains(target)) return;

    // Convert input to array
    const ignoreSelectors = Array.isArray(this.appClickOutsideExcept)
      ? this.appClickOutsideExcept
      : [this.appClickOutsideExcept];

    // If clicked inside ignored element → ignore
    for (const selector of ignoreSelectors) {
      const el = document.querySelector(selector);
      if (el && el.contains(target)) return;
    }

    // Otherwise emit
    this.clickOutside.emit();
  }
}
